import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Handle the OAuth callback and session setup
    const handleAuthCallback = async () => {
      try {
        // Get the current session
        const { data: { session }, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error('Error getting session:', error.message);
          navigate('/signin');
          return;
        }
        
        if (session) {
          // Always redirect to dashboard after successful authentication
          navigate('/dashboard');
        } else {
          // If no session, redirect to sign in
          navigate('/signin');
        }
      } catch (err) {
        console.error('Unexpected error during auth callback:', err);
        navigate('/signin');
      }
    };

    handleAuthCallback();
  }, [navigate]);

  return (
    <div className="flex justify-center items-center h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      <p className="ml-3 text-gray-600">Authenticating...</p>
    </div>
  );
};

export default AuthCallback;
